export enum ApiErrorCode {
    ApiErrorUnspecified = 0,
    ApiErrorUnsupportedGrantType,
    ApiErrorInvalidCredentials,
    ApiErrorUnauthorized,
    ApiErrorUnsupportedMediaType,
    ApiErrorBadRequest,
    ApiErrorTooManyApiKeys,
    ApiErrorNotFound,
    ApiErrorUnprocessableEntity,
    ApiErrorForbidden,
    ApiErrorConflict,
};
